/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'edit': {
    width: 18,
    height: 18,
    viewBox: '0 0 18 18',
    data: '<g _fill="none" fill-rule="evenodd"><path pid="0" d="M1.72 13.481l-.11.113a.324.324 0 00-.083.12l-1.5 3.75a.375.375 0 00.082.405.366.366 0 00.405.082l3.75-1.5a.356.356 0 00.189-.165c.009-.007.02-.022.033-.037L1.72 13.48M17.42.551c-.74-.735-2.029-.735-2.768 0l-1.9 1.905 2.764 2.76c.601-.592 1.235-1.222 1.903-1.882.373-.368.58-.863.58-1.38A1.976 1.976 0 0017.422.55M12.222 2.981L2.25 12.95 5.002 15.7c.996-1.027 3.596-3.637 9.98-9.96l-2.76-2.76"/></g>'
  }
})
